import HeroEditPrimaryButton from './HeroEditPrimaryButton';

export default HeroEditPrimaryButton;
